export default {
  shape:
    '<path fill="#000" fill-opacity=".51" d="M10.95 14.85 15.9 9.9l-.7-.725-4.25 4.25L8.8 11.3l-.7.7 2.85 2.85Zm1.05 6.1c-2.017-.583-3.688-1.796-5.013-3.638C5.662 15.471 5 13.4 5 11.1V5.7l7-2.625L19 5.7v5.4c0 2.3-.663 4.37-1.988 6.212-1.325 1.842-2.995 3.055-5.012 3.638Zm0-1.05c1.733-.55 3.167-1.65 4.3-3.3s1.7-3.483 1.7-5.5V6.375L12 4.15 6 6.375V11.1c0 2.017.567 3.85 1.7 5.5s2.567 2.75 4.3 3.3Z"/>',
  viewBox: [0, 0, 24, 24],
};
